import db from "../db/database";

// Servicio para manejar las direcciones de clientes (solo consulta)

// Obtener todas las direcciones de un cliente por su número
export const getClientAddressesByNo = async (customerNo) => {
	try {
		const addresses = await db.clientAddresses
			.where("CustomerNo")
			.equals(customerNo)
			.toArray();

		return addresses;
	} catch (error) {
		console.error(
			`Error al obtener direcciones del cliente ${customerNo}:`,
			error
		);
		throw error;
	}
};

// Obtener una dirección específica por código
export const getClientAddressByCode = async (code) => {
	try {
		const address = await db.clientAddresses.where("Code").equals(code).first();

		if (!address) {
			throw new Error("Dirección no encontrada");
		}

		return address;
	} catch (error) {
		console.error(`Error al obtener dirección con código ${code}:`, error);
		throw error;
	}
};

// Obtener todas las direcciones (para uso interno del sistema)
export const getAllClientAddresses = async () => {
	try {
		const addresses = await db.clientAddresses.toArray();
		return addresses;
	} catch (error) {
		console.error("Error al obtener todas las direcciones:", error);
		throw error;
	}
};

// Función interna para agregar direcciones desde sincronización
export const addClientAddressFromSync = async (address) => {
	try {
		const id = await db.clientAddresses.add({
			CustomerNo: address.CustomerNo,
			Code: address.Code,
			Name: address.Name,
			Ciudad: address.Ciudad,
			Provincia: address.Provincia,
			Email: address.Email || "",
			Teléfono: address.Teléfono || "",
			lastSynced: new Date(),
		});

		return { id, ...address };
	} catch (error) {
		console.error("Error al agregar dirección desde sincronización:", error);
		throw error;
	}
};

// Función interna para actualizar direcciones desde sincronización
export const updateClientAddressFromSync = async (code, addressData) => {
	try {
		const existingAddress = await db.clientAddresses
			.where("Code")
			.equals(code)
			.first();

		if (existingAddress) {
			await db.clientAddresses.update(existingAddress.id, {
				...addressData,
				lastSynced: new Date(),
			});

			return await getClientAddressByCode(code);
		} else {
			return await addClientAddressFromSync({ Code: code, ...addressData });
		}
	} catch (error) {
		console.error(`Error al actualizar dirección ${code}:`, error);
		throw error;
	}
};
